import { createContext, useContext } from 'react';

type ModalContextType = {
  mountSkipButton: VoidFunction;
};

const ModalContext = createContext<ModalContextType>({
  mountSkipButton: () => {},
});

export const ModalProvider = ModalContext.Provider;
export const useModalContext = () => useContext(ModalContext);
